import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showThreeSixty: false,
  fullscreen: false,
};

const carousalSlice = createSlice({
  name: "carousal",
  initialState,
  reducers: {
    openThreeSixtyView: (state) => {
      state.showThreeSixty = true;
    },
    closeThreeSixtyView: (state) => {
      state.showThreeSixty = false;
    },
    handleFullscreen: (state) => {
      state.fullscreen = !state.fullscreen;
    },
  },
});

export const { openThreeSixtyView, closeThreeSixtyView, handleFullscreen } =
  carousalSlice.actions;

export default carousalSlice.reducer;
